/**
 * Funnel tracking for the homepage hero, the chat CV builder.
 *
 * The hero used to be an A/B test of the paste generator (`paste`) against the
 * chat builder (`chat`). The test is over and every visitor now gets the chat,
 * but its events keep the experiment's labels so /admin/ab-test goes on
 * reporting the chat funnel next to the data collected during the test.
 */
export const HERO_EXPERIMENT = 'hero_chat_v1'
export type HeroVariant = 'paste' | 'chat'

export function useHeroExperiment() {
  const variant: HeroVariant = 'chat'
  const isReady = useState('hero-variant-ready', () => false)
  // Taken in setup: both need the Nuxt context, which is gone by the time an
  // event fires from a click handler after an await.
  const gtm = import.meta.client ? useGTM() : null
  const analytics = useAnalytics()

  /** Reports the page view of the hero once per page view. */
  function resolve() {
    if (!import.meta.client || isReady.value) return
    isReady.value = true
    track('ab_exposure')
  }

  /**
   * One event to both places the funnel is read from: GTM (GA4) and the
   * site's own analytics table in /admin/analytics.
   */
  function track(name: string, data: Record<string, unknown> = {}) {
    if (!import.meta.client) return
    const payload = { experiment: HERO_EXPERIMENT, variant, ...data }
    try {
      gtm?.trackEvent(name, payload)
    } catch {
      /* GTM blocked or not loaded */
    }
    analytics.trackCustomEvent(name, payload).catch(() => {})
  }

  return { variant, isReady, resolve, track }
}
